import { Router } from "./routes/Router";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import queryClient from "./queryClient";
import { useEffect } from "react";
import { useAppLayout } from "@dataone/lib";
import { Amplify } from "aws-amplify";
import { COGNITO } from "./cognito.config";

const hostname = window.location.hostname;
const env =
  COGNITO[
    hostname === "localhost"
      ? "development"
      : hostname === "workspace.onegate.ai"
      ? "production"
      : "preproduction"
  ];

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: env.CLIENT_ID,
      userPoolId: env.USER_POOL_ID,
      loginWith: {
        oauth: {
          domain: env.APP_DOMAIN,
          scopes: [
            "aws.cognito.signin.user.admin",
            "email",
            "openid",
            "profile",
          ],
          redirectSignIn: [env.REDIRECT_URL],
          redirectSignOut: [env.LOGOUT_URL],
          responseType: "token",
        },
      },
    },
  },
});

function App() {
  useEffect(() => {
    return () => {
      useAppLayout.setState({ isSmartSearchVisible: false });
      useAppLayout.setState({ isResponseVisible: false });
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Router />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
